export const en = {
    'banner-id': 'No. {id}'
};
